import { HttpEventType, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { retry, tap, throwError, timer } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ConnectivityService } from '../connectivity/connectivity.service';
import { isTransientError } from '../connectivity/transient-error';

const MAX_RETRIES = 2;
const BASE_BACKOFF_MS = 500;

/**
 * Nur lesende Anfragen werden wiederholt und schalten das Banner ein: Ein POST/PUT/PATCH/DELETE
 * kann beim Server schon angekommen sein, bevor das Gateway mit 502/504 antwortet — eine
 * Wiederholung könnte doppelt anlegen oder ändern. Schreibende Anfragen meldet das Formular selbst.
 */
export const serverUnavailableInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(`${environment.apiBaseUrl}/api/`)) {
    return next(req);
  }
  const connectivity = inject(ConnectivityService);
  const ticket = connectivity.registerRequest();
  const isRead = req.method === 'GET';
  const response$ = isRead
    ? next(req).pipe(
        retry({
          count: MAX_RETRIES,
          delay: (error: unknown, attempt: number) =>
            isTransientError(error) ? timer(BASE_BACKOFF_MS * 2 ** (attempt - 1)) : throwError(() => error),
        }),
      )
    : next(req);

  return response$.pipe(
    tap({
      next: (event) => {
        if (event.type === HttpEventType.Response) {
          connectivity.setAvailable(ticket);
        }
      },
      error: (error: unknown) => {
        if (isRead && isTransientError(error)) {
          connectivity.setUnavailable();
        }
      },
    }),
  );
};
